import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import UserContext from '../../context/UserContext.js';
import BotoneraTecnico from './BotoneraTecnico.js';
import ComboSelectorJugador from '../UI/campos/ComboSelectorJugador.js';
import BotonImagen from '../UI/botones/BotonImagen.js';
import { PersonaFormacion as Campos } from '../constantes/Campos.js';
import { ORDEN_TECNICOS } from '../Constants.js';
import * as Funciones from '../funciones/FuncionesFormacion.js';
import { Boton } from '../funciones/FuncionesFormacion.js';
import * as FuncionesPersona from '../funciones/FuncionesPersona.js';
import * as Iconos from '../UI/Iconos.js';
import styles from './TecnicoFormacion.module.css';

const TecnicoFormacion = (props) => {
  const formacion = props.formacion;
  const plantel = props.plantel;
  const tecnico = props.tecnico;
  const { usuario } = useContext(UserContext);
  const puedeEditar = usuario && usuario.puedeEditar;
  const [editar, setEditar] = useState(false);
  const [modoPersonaSinId, setModoPersonaSinId] = useState(false);
  const [apellidoSinId, setApellidoSinId] = useState('');
  const [nombreSinId, setNombreSinId] = useState('');

  const onClickBoton = (boton) => {
    if (puedeEditar) {
      switch (boton) {
        case Boton.EDITAR: {
          setEditar(true);
          // Si hay personaSinId, activar modo edición de personaSinId
          if (tecnico.personaSinId) {
            setModoPersonaSinId(true);
            setApellidoSinId(tecnico.personaSinId.apellido || '');
            setNombreSinId(tecnico.personaSinId.nombre || '');
          }

          break;
        }
        case Boton.CANCELAR: {
          setEditar(false);
          setModoPersonaSinId(false);
          setApellidoSinId('');
          setNombreSinId('');

          break;
        }
        case Boton.BORRAR: {
          setEditar(false);
          setModoPersonaSinId(false);
          setApellidoSinId('');
          setNombreSinId('');
          // Llamar al handler de eliminación si existe
          if (props.onEliminar) {
            props.onEliminar(tecnico);
          } else {
            // Fallback: solo limpiar campos
            props.actualizarCampo(tecnico, Campos.PERSONA, null);
            if (tecnico.personaSinId) {
              props.actualizarCampo(tecnico, Campos.PERSONA_SIN_ID, null);
            }
          }

          break;
        }
        default: {
          props.onClick(tecnico, boton);
        }
      }
    }
  };

  const onPersonaElegida = (persona) => {
    if (puedeEditar) {
      if (Funciones.ValidarPersonaLibre(formacion, tecnico, persona)) {
        setEditar(false);
        props.actualizarCampo(tecnico, Campos.PERSONA, persona);
      } else {
        alert('El tecnico ya está asignado a la formación');
      }
    }
  };

  const onToggleModoPersonaSinId = () => {
    setModoPersonaSinId(!modoPersonaSinId);
    setApellidoSinId('');
    setNombreSinId('');
  };

  const onConfirmarPersonaSinId = () => {
    if (apellidoSinId.trim().length >= 2) {
      const personaSinId = {
        apellido: apellidoSinId.trim(),
        nombre: nombreSinId.trim(),
      };
      props.actualizarCampo(tecnico, Campos.PERSONA_SIN_ID, personaSinId);
      setEditar(false);
      setModoPersonaSinId(false);
      setApellidoSinId('');
      setNombreSinId('');
    } else {
      alert('Debe ingresar al menos 2 caracteres en el apellido');
    }
  };

  let campoTecnico = '';
  if (puedeEditar) {
    // Verificar si tiene datos válidos
    const tienePersona = tecnico.persona && tecnico.persona.id;
    const tienePersonaSinId =
      tecnico.personaSinId &&
      tecnico.personaSinId.apellido &&
      tecnico.personaSinId.apellido.trim().length > 0;

    if ((tienePersona || tienePersonaSinId) && !editar) {
      if (tienePersona) {
        campoTecnico = (
          <Link
            className={`${styles.link}`}
            to={'/persona/' + (tecnico.persona && tecnico.persona.id)}
            target="_blank"
            rel="noopener noreferrer"
          >
            {FuncionesPersona.ApellidoNombre(tecnico.persona)}
          </Link>
        );
      } else {
        campoTecnico = (
          <div className={`${styles.link}`}>
            {tecnico.personaSinId ? FuncionesPersona.ApellidoNombreSinId(tecnico.personaSinId) : ''}
          </div>
        );
      }
    } else {
      if (modoPersonaSinId) {
        // Modo: Ingresar persona sin ID
        campoTecnico = (
          <div className={`${styles.formPersonaSinId}`}>
            <input
              type="text"
              placeholder="Apellido"
              value={apellidoSinId}
              onChange={(e) => setApellidoSinId(e.target.value)}
              className={`${styles.inputPersonaSinId}`}
            />
            <input
              type="text"
              placeholder="Nombre"
              value={nombreSinId}
              onChange={(e) => setNombreSinId(e.target.value)}
              className={`${styles.inputPersonaSinId}`}
            />
            <BotonImagen
              name="confirmar"
              imagen={Iconos.aceptar}
              width="15px"
              height="15px"
              alt="Confirmar"
              onClick={onConfirmarPersonaSinId}
            />
            <BotonImagen
              name="cancelar"
              imagen={Iconos.personaSinIdCancelar}
              width="15px"
              height="15px"
              alt="Volver al combo"
              onClick={onToggleModoPersonaSinId}
            />
          </div>
        );
      } else {
        // Modo: Combo de selección
        const tecnicos = plantel.filter(
          (item) => item.puesto && item.puesto.orden >= ORDEN_TECNICOS
        );
        campoTecnico = (
          <div className={`${styles.comboConBoton}`}>
            <ComboSelectorJugador
              lista={tecnicos}
              valorActual={
                tecnico.persona ? FuncionesPersona.ApellidoNombrePuesto(tecnico.persona) : ''
              }
              onItemElegido={onPersonaElegida}
            />
            <BotonImagen
              name="personaSinId"
              imagen={Iconos.personaSinIdAgregar}
              width="15px"
              height="15px"
              alt="Ingresar persona sin ID"
              onClick={onToggleModoPersonaSinId}
            />
          </div>
        );
      }
    }
  } else {
    // Modo sin permiso de edición
    const tienePersona = tecnico.persona && tecnico.persona.id;
    const tienePersonaSinId =
      tecnico.personaSinId &&
      tecnico.personaSinId.apellido &&
      tecnico.personaSinId.apellido.trim().length > 0;

    if (tienePersona) {
      campoTecnico = (
        <Link
          className={`${styles.link}`}
          to={'/persona/' + (tecnico.persona && tecnico.persona.id)}
          target="_blank"
          rel="noopener noreferrer"
        >
          {tecnico.persona ? FuncionesPersona.ApellidoNombre(tecnico.persona) : ''}
        </Link>
      );
    } else if (tienePersonaSinId) {
      campoTecnico = (
        <div className={`${styles.link}`}>
          {FuncionesPersona.ApellidoNombreSinId(tecnico.personaSinId)}
        </div>
      );
    }
  }

  return (
    <React.Fragment>
      {tecnico && campoTecnico && (
        <div className={`${styles.fila}`}>
          <div className={`${styles.espacio}`} />
          <div className={`${styles.tecnico}`}>{campoTecnico}</div>
          {puedeEditar && (
            <div className={`${styles.detalles} ${editar && styles.editar}`}>
              <BotoneraTecnico tecnico={tecnico} editar={editar} onClickBoton={onClickBoton} />
            </div>
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default TecnicoFormacion;
